import React from "react";
import Component from "../components/login/Component";

const Login = () => {
  return <Component />;
};

export default Login;
